// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__37HCS","selected":"Chip_selected__3JT9d"};